<div>
  <div class="user-info">
    @if (showAvatar) {
      <div class="image-container">
        @if (user?.avatarSource) {
          <div
            [style.backgroundImage]="'url(' + user.avatarSource + ')'"
            class="user-image"
          ></div>
        } @else {
          <div class="user-image user-image-default">
            <i class="dx-icon dx-icon-user"></i>
          </div>
        }
      </div>
    }
    <div class="user-name">{{ user?.name }}</div>
  </div>
  <dx-list
    #userInfoList
    [items]="menuItems"
    [elementAttr]="{
      class: 'user-info-list'
    }"
    (onItemClick)="handleListItemClick($event)"
  ></dx-list>
</div>
